export default __webpack_public_path__ + "static/media/forestly-expl-dissect-base_EN.911e36da.png";